var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lock-screen-btn-con",on:{"click":_vm.lock}},[_c('Tooltip',{attrs:{"content":_vm.L('LockScreen'),"placement":"bottom"}},[_c('i',{staticClass:"iconfont",staticStyle:{"font-size":"20px"}},[_vm._v("")])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-915a618a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lockscreen/lockscreen.vue
// module id = null
// module chunks = 